export enum PricingProduct {
  LineOfCredit = 'LineOfCredit',
  InHouseCredit = 'InHouseCredit',
  ArAdvance = 'ARAdvance',
}
